module.exports = __webpack_public_path__ + "img/cellTeam_online.b094f74b.png";